import {ActionType} from './types'

export const actionDefaultLabel = (type: ActionType) => {
  if (type === 'view') {
    return 'GENERAL.VIEW'
  } else if (type === 'edit') {
    return 'GENERAL.UPDATE'
  } else if (type === 'delete') {
    return 'GENERAL.DELETE'
  }
  return null
}

export const actionDefaultIcon = (type: ActionType) => {
  if (type === 'view') {
    return 'fas fa-eye'
  } else if (type === 'edit') {
    return 'fas fa-pen'
  } else if (type === 'delete') {
    return 'fas fa-trash-can'
  }
  return null
}

export const actionDefaultColor = (type: ActionType) => {
  if (type === 'view') {
    return 'light-info'
  } else if (type === 'edit') {
    return 'light-primary'
  } else if (type === 'delete') {
    return 'light-danger'
  }
  return null
}
